import { Box, Typography, styled } from "@mui/material";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import { Link } from "react-router";
import { useBreadcrumb } from "../contexts/BreadcrumbContext.jsx";

const BreadcrumbArea = styled(Box)({
  flex: 1,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  minWidth: 0,
  flexWrap: "wrap",
});

/**
 * The current breadcrumb trail, every step a link. Placed on the left of a
 * portal's header; the pages set the trail via useBreadcrumb().
 */
export default function Breadcrumbs() {
  const { breadcrumbs } = useBreadcrumb();

  return (
    <BreadcrumbArea>
      {breadcrumbs.map((crumb, index) => (
        <Box
          key={index}
          sx={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          {index > 0 && (
            <ChevronRightIcon
              sx={{
                fontSize: "24px",
                color: "text.primary",
              }}
            />
          )}
          <Typography
            component={Link}
            to={crumb.path}
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: 1.5,
              color: "text.primary",
              textDecoration: "none",
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            {crumb.name}
          </Typography>
        </Box>
      ))}
    </BreadcrumbArea>
  );
}
